var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardLinkSupportService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0392 3.9704C30.4541 0.399148 25.2993 0 19 0C12.6927 0 7.53007 0.40375 3.9465 3.98465C0.363448 7.56406 0 12.7184 0 19.0184C0 25.3195 0.363448 30.4754 3.94798 34.0561C7.53133 37.6375 12.6934 38 19 38C25.3066 38 30.4678 37.6375 34.0511 34.0561C37.6354 30.4748 37.9999 25.3195 37.9999 19.0184C37.9999 12.7103 37.6315 7.55041 34.0392 3.9704Z",
    fill: "#ABB6CD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7113_17405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1438 22.5538V16.9823C29.1438 11.4436 24.6538 6.95361 19.1151 6.95361C13.5764 6.95361 9.08643 11.4436 9.08643 16.9823V22.5538",
    stroke: "#2D4982",
    strokeWidth: 1.67145
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2588 20.8831V23.1117",
    stroke: "#2D4982",
    strokeWidth: 1.67145,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97217 20.8831V23.1117",
    stroke: "#2D4982",
    strokeWidth: 1.67145,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6579 19.0391C14.6579 18.1873 14.6579 17.7614 14.4632 17.4653C14.3652 17.3163 14.2352 17.1931 14.0834 17.1057C13.7818 16.9319 13.3744 16.972 12.5596 17.0524C11.1867 17.1877 10.5003 17.2554 10.0084 17.626C9.7594 17.8135 9.55039 18.0526 9.39448 18.3283C9.08643 18.8729 9.08643 19.5906 9.08643 21.0259V22.7705C9.08643 24.1915 9.08643 24.902 9.40063 25.4507C9.51824 25.6561 9.66565 25.8413 9.83764 25.9998C10.2971 26.4233 10.9679 26.5555 12.3093 26.8201C13.2533 27.0062 13.7253 27.0993 14.0736 26.9033C14.2022 26.8309 14.3158 26.733 14.408 26.615C14.6579 26.2953 14.6579 25.7953 14.6579 24.7953V19.0391Z",
    stroke: "#2D4982",
    strokeWidth: 1.67145
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.572 19.0391C23.572 18.1873 23.572 17.7614 23.7667 17.4653C23.8647 17.3163 23.9948 17.1931 24.1466 17.1057C24.4482 16.9319 24.8556 16.972 25.6703 17.0524C27.0432 17.1877 27.7297 17.2554 28.2216 17.626C28.4705 17.8135 28.6796 18.0526 28.8355 18.3283C29.1435 18.8729 29.1435 19.5906 29.1435 21.0259V22.7705C29.1435 24.1915 29.1435 24.902 28.8293 25.4507C28.7117 25.6561 28.5643 25.8413 28.3923 25.9998C27.9328 26.4233 27.2621 26.5555 25.9207 26.8201C24.9767 27.0062 24.5047 27.0993 24.1563 26.9033C24.0278 26.8309 23.9142 26.733 23.8219 26.615C23.572 26.2953 23.572 25.7953 23.572 24.7953V19.0391Z",
    stroke: "#2D4982",
    strokeWidth: 1.67145
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1393 28.3697V25.0798H29.8064V28.3697C29.8064 29.9442 28.438 31.2205 26.7501 31.2205L25.7073 31.2205C25.247 31.2205 24.8738 30.8724 24.8738 30.443C24.8738 30.0136 25.247 29.6656 25.7073 29.6656H26.7501C27.5173 29.6656 28.1393 29.0854 28.1393 28.3697Z",
    fill: "#2D4982"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7113_17405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3635,
    height: 29.3636,
    fill: "white",
    transform: "translate(4.31812 4.31812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLinkSupportService);
export default __webpack_public_path__ + "static/media/card_link_support_service.0ee80d29847e7f896bc019efd6919781.svg";
export { ForwardRef as ReactComponent };